// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const summaryApiAuditLogSummaryGetParamsActorOneItemMax = 320;

export const summaryApiAuditLogSummaryGetParamsActorOneMax = 50;

export const summaryApiAuditLogSummaryGetParamsActionOneItemMax = 80;

export const summaryApiAuditLogSummaryGetParamsActionOneMax = 50;

export const summaryApiAuditLogSummaryGetParamsEventFamilyOneItemMax = 80;

export const summaryApiAuditLogSummaryGetParamsEventFamilyOneMax = 50;

export const summaryApiAuditLogSummaryGetParamsOutcomeOneItemMax = 80;

export const summaryApiAuditLogSummaryGetParamsOutcomeOneMax = 50;

export const summaryApiAuditLogSummaryGetParamsEntityTypeOneItemMax = 80;

export const summaryApiAuditLogSummaryGetParamsEntityTypeOneMax = 50;

export const summaryApiAuditLogSummaryGetParamsEntityIdOneMax = 64;

export const summaryApiAuditLogSummaryGetParamsSourceIpOneMax = 100;

export const summaryApiAuditLogSummaryGetParamsTracedDefault = false;
export const SummaryApiAuditLogSummaryGetParams = zod.object({
  "occurred_from": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).optional(),
  "occurred_to": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).optional(),
  "actor": zod.union([zod.array(zod.string().max(summaryApiAuditLogSummaryGetParamsActorOneItemMax)).max(summaryApiAuditLogSummaryGetParamsActorOneMax),zod.null()]).optional(),
  "actor_user_id": zod.union([zod.uuid(),zod.null()]).optional(),
  "action": zod.union([zod.array(zod.string().max(summaryApiAuditLogSummaryGetParamsActionOneItemMax)).max(summaryApiAuditLogSummaryGetParamsActionOneMax),zod.null()]).optional(),
  "event_family": zod.union([zod.array(zod.string().max(summaryApiAuditLogSummaryGetParamsEventFamilyOneItemMax)).max(summaryApiAuditLogSummaryGetParamsEventFamilyOneMax),zod.null()]).optional(),
  "outcome": zod.union([zod.array(zod.string().max(summaryApiAuditLogSummaryGetParamsOutcomeOneItemMax)).max(summaryApiAuditLogSummaryGetParamsOutcomeOneMax),zod.null()]).optional(),
  "entity_type": zod.union([zod.array(zod.string().max(summaryApiAuditLogSummaryGetParamsEntityTypeOneItemMax)).max(summaryApiAuditLogSummaryGetParamsEntityTypeOneMax),zod.null()]).optional(),
  "entity_id": zod.union([zod.string().max(summaryApiAuditLogSummaryGetParamsEntityIdOneMax),zod.null()]).optional(),
  "source_ip": zod.union([zod.string().max(summaryApiAuditLogSummaryGetParamsSourceIpOneMax),zod.null()]).optional(),
  "traced": zod.boolean().default(summaryApiAuditLogSummaryGetParamsTracedDefault)
})

export type SummaryApiAuditLogSummaryGetParams = zod.input<typeof SummaryApiAuditLogSummaryGetParams>;
export type SummaryApiAuditLogSummaryGetParamsOutput = zod.output<typeof SummaryApiAuditLogSummaryGetParams>;
